import { createSlice } from '@reduxjs/toolkit';
import { TokenResponse } from '../views/Airdrops/Airdrop.types';
import { getAirdrops } from '../views/Airdrops/Airdrop.actions';

export interface AirdropsType {
  loading: boolean;
  tokens: TokenResponse;
}

const initialState = {
  loading: false,
  tokens: {}
} as AirdropsType;

const airdropsSlice = createSlice({
  name: 'airdrops',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getAirdrops.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAirdrops.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.tokens = payload;
    });
    builder.addCase(getAirdrops.rejected, (state) => {
      state.loading = false;
    });
  }
});

export default airdropsSlice.reducer;
